// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs___-1lvkH4qx72oj4RIrxvD3a0","tabs__item":"tabs__item___-1hArCZ0wlH31OBHTOjVgrr","active":"active___-71Fiyjq4U-c5SSL6Cn997"};